// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import MuiSnackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";

// Vision UI components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Custom icon wrapper (reused)
import SnackbarIconRoot from "./SnackbarIconRoot";

function Snackbar({ color, icon, title, content, close, origin = "bottom", bgWhite, ...rest }) {
  const titleColor = bgWhite ? color : "white";
  const dividerColor = !bgWhite;

  return (
    <MuiSnackbar
      TransitionComponent={Fade}
      autoHideDuration={3000}
      onClose={close}
      anchorOrigin={{
        vertical: origin,
        horizontal: "right",
      }}
      {...rest}
      action={
        <IconButton size="small" aria-label="close" color="inherit" onClick={close}>
          <Icon fontSize="small">close</Icon>
        </IconButton>
      }
    >
      <VuiBox
        variant={bgWhite ? "contained" : "gradient"}
        bgColor={bgWhite ? "white" : color}
        minWidth="21.875rem"
        maxWidth="100%"
        shadow="md"
        borderRadius="lg"
        p={0.5}
      >
        {/* Header */}
        <VuiBox display="flex" justifyContent="space-between" alignItems="center" p={1}>
          <VuiBox display="flex" alignItems="center" gap={1}>
            <SnackbarIconRoot ownerState={{ color, bgWhite }}>{icon}</SnackbarIconRoot>

            <VuiTypography variant="button" fontWeight="medium" color={titleColor}>
              {title}
            </VuiTypography>
          </VuiBox>

          <Icon
            sx={{
              color: bgWhite ? "grey.700" : "white",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={close}
          >
            close
          </Icon>
        </VuiBox>

        {/* <Divider light={dividerColor} /> */}

        {/* Content */}
        <VuiBox p={1}>
          <VuiTypography variant="caption" color={bgWhite ? "text" : "white"}>
            {content}
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </MuiSnackbar>
  );
}

// Default props
Snackbar.defaultProps = {
  bgWhite: false,
  color: "info",
};

// PropTypes
Snackbar.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  close: PropTypes.func.isRequired,
  bgWhite: PropTypes.bool,
};

export default Snackbar;
